import { Event } from "types";
import { validateParams } from "../hookHelpers";
import { ResourceFetchOptions, useResource } from "../useResource";

export const useEvent = (
    eventId: string | undefined,
    params: any = null,
    options: ResourceFetchOptions<Event> = {},
) => {
    params = validateParams(params);

    const response = useResource<Event>(["events", eventId], params, options);
    return { ...response, event: response.data, isLoadingEvent: response.isLoading };
};
